module.exports = __webpack_public_path__ + "static/assets/987458d8ccbd16600fdc3275c9880917.svg";